export default __webpack_public_path__ + "static/media/moreAboutIndexRate.740dd7bf.svg";